import React from 'react'

export default function NotFound() {
    return (
        <h1>Oopsie! Looks like you tried to go somewhere that doesn't exist!</h1>
    )
}